import {useCallback, useEffect, useState} from "react";

import {sessionCache} from "@pg-rp/session-cache";

import {CREDIT_OFFERS_UNLOCKED} from "../../app/constants/storage_keys";

const UNLOCK_EVENT = "credit-offers-unlocked";

export const useCreditPaywall = () => {
    const [areOffersUnlocked, setAreOffersUnlocked] = useState<boolean>(() => {
        return sessionCache.get<boolean>(CREDIT_OFFERS_UNLOCKED) ?? false;
    });

    useEffect(() => {
        const handleUnlock = () => {
            setAreOffersUnlocked(true);
        };

        window.addEventListener(UNLOCK_EVENT, handleUnlock);

        return () => {
            window.removeEventListener(UNLOCK_EVENT, handleUnlock);
        };
    }, []);

    const unlockOffers = useCallback(() => {
        sessionCache.set(CREDIT_OFFERS_UNLOCKED, true);
        setAreOffersUnlocked(true);

        window.dispatchEvent(new Event(UNLOCK_EVENT));
    }, []);

    return {
        areOffersUnlocked,
        unlockOffers
    };
};
import {useCallback, useEffect, useState} from "react";

import {sessionCache} from "@pg-rp/session-cache";

import {CREDIT_OFFERS_UNLOCKED} from "../../app/constants/storage_keys";

const UNLOCK_EVENT = "credit-offers-unlocked";

export const useCreditPaywall = () => {
    const [areOffersUnlocked, setAreOffersUnlocked] = useState<boolean>(() => {
        return sessionCache.get<boolean>(CREDIT_OFFERS_UNLOCKED) ?? false;
    });

    useEffect(() => {
        const handleUnlock = () => {
            setAreOffersUnlocked(true);
        };

        window.addEventListener(UNLOCK_EVENT, handleUnlock);

        return () => {
            window.removeEventListener(UNLOCK_EVENT, handleUnlock);
        };
    }, []);

    const unlockOffers = useCallback(() => {
        sessionCache.set(CREDIT_OFFERS_UNLOCKED, true);
        setAreOffersUnlocked(true);

        window.dispatchEvent(new Event(UNLOCK_EVENT));
    }, []);

    return {
        areOffersUnlocked,
        unlockOffers
    };
};
